import type { ReportJSON } from '@aloft/toolkit-shared';
import { isDefined } from '@aloft/toolkit-shared';

import { createTextFieldNode } from './createTextFieldNode.ts';

type Tkv2UADAnnotationRptiNodeInput =
  | {
      property: ReportJSON['subject']['property'];
      isComp: false | undefined;
      meta?: ReportJSON['meta'];
    }
  | {
      property: ReportJSON['comps'][string];
      isComp: true;
      meta?: ReportJSON['meta'];
      compIndex: number;
    };

export const generateTkv2UADAnnotationRptiNodes = (
  doc: Document,
  nodeInput: Tkv2UADAnnotationRptiNodeInput,
) => {
  const { property } = nodeInput;
  const rptiNodes = [];
  const additionalAttributes = nodeInput.isComp
    ? {
        BaseCompIndex: String(nodeInput.compIndex + 1),
        CompType: 'SalesComparables',
      }
    : {};

  // // Data source
  // const dataSource = property.getGridField('DataSourceDescription');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'DataSources',
  //         Data: dataSource,
  //         additional: additionalAttributes,
  //     })
  // );

  // // Data Source Verification Description
  // const dataSourceVerificationDescription = property.getGridField(
  //     'DataSourceVerificationDescription'
  // );
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'VerificationSources',
  //         Data: dataSourceVerificationDescription,
  //         additional: additionalAttributes,
  //     })
  // );

  // // add Address to the list of nodes
  // const structuredAddress = property.getStructuredData('address');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'PropertyAddress',
  //         Data: structuredAddress?.AddressLineText,
  //         additional: additionalAttributes,
  //     })
  // );

  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'PropertyCity',
  //         Data: structuredAddress?.CityName,
  //         additional: additionalAttributes,
  //     })
  // );

  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'PropertyState',
  //         Data: structuredAddress?.StateCode,
  //         additional: additionalAttributes,
  //     })
  // );

  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'PropertyZip',
  //         Data: structuredAddress?.PostalCode,
  //         additional: additionalAttributes,
  //     })
  // );

  // Add Sale price
  const salePrice = property.salesGridData.annotations.PropertySalesAmount;
  rptiNodes.push(
    createTextFieldNode(doc, {
      Id: 'SalePriceAmount',
      Data: salePrice,
      additional: additionalAttributes,
    }),
  );

  // // term of sale
  // const termsOfSale = property.getGridField('SalesConcessions');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'SaleConcessionsDescription',
  //         Data: termsOfSale,
  //         additional: additionalAttributes,
  //     })
  // );

  // // concession amount
  // const concessions = property.getGridField('FinancingConcessions');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'FinancingConcessionsDescription',
  //         Data: concessions,
  //         additional: additionalAttributes,
  //     })
  // );

  // // listing status
  // const listingStatus = property.getStructuredData('status');
  // TODO - Find the right mapping when we want annotations exported.

  // // Date of sale
  // const dateOfSale = property.getGridField('DateOfSale');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'SaleDateDescription',
  //         Data: dateOfSale,
  //         additional: additionalAttributes,
  //     })
  // );

  // // Location
  // const location = property.getGridField('Location');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'LocationDesciption',
  //         Data: location,
  //         additional: additionalAttributes,
  //     })
  // );

  // // Property Rights
  // const propertyRights = property.getGridField('PropertyRights');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'PropertyRightsDescription',
  //         Data: propertyRights,
  //         additional: additionalAttributes,
  //     })
  // );

  // // Site Area
  // const siteArea = property.getGridField('SiteArea');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'SiteDescription',
  //         Data: siteArea,
  //         additional: additionalAttributes,
  //     })
  // );

  // // view
  // const view = property.getGridField('View');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'ViewDescription',
  //         Data: view,
  //         additional: additionalAttributes,
  //     })
  // );

  // // Design Style
  // const designStyle = property.getGridField('DesignStyle');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'DesignStyleDescription',
  //         Data: designStyle,
  //         additional: additionalAttributes,
  //     })
  // );

  // // Quality
  // const quality = property.getGridField('Quality');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'QualityDescription',
  //         Data: quality,
  //         additional: additionalAttributes,
  //     })
  // );

  // // Age
  // const age = property.getGridField('Age');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'AgeDescription',
  //         Data: age,
  //         additional: additionalAttributes,
  //     })
  // );

  // // Condition
  // const condition = property.getGridField('Condition');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'ConditionDescription',
  //         Data: condition,
  //         additional: additionalAttributes,
  //     })
  // );

  // // Total Rooms
  // const totalRooms = property.getGridField('TotalRoomCount');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'RoomCountTotal',
  //         Data: totalRooms,
  //         additional: additionalAttributes,
  //     })
  // );

  // // Bedrooms
  // const bedrooms = property.getGridField('TotalBedroomCount');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'RoomCountBedrooms',
  //         Data: bedrooms,
  //         additional: additionalAttributes,
  //     })
  // );

  // // Bathrooms
  // const bathrooms = property.getGridField('TotalBathroomCount');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'RoomCountBathrooms',
  //         Data: bathrooms,
  //         additional: additionalAttributes,
  //     })
  // );

  // // gla
  const gla = property.salesGridData.annotations.GrossLivingArea;
  rptiNodes.push(
    createTextFieldNode(doc, {
      Id: 'GrossLivingArea',
      Data: gla,
      additional: additionalAttributes,
    }),
  );

  // // basement area
  // const basementArea = property.getGridField('BasementArea');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'BasementDescription',
  //         Data: basementArea,
  //         additional: additionalAttributes,
  //     })
  // );

  // // basement finish
  // const basementFinish = property.getGridField('BasementFinish');
  // TODO - Find the right mapping when we want annotations exported.

  // // functional utility
  // const functionalUtility = property.getGridField('FunctionalUtility');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'FunctionalUtilityDescription',
  //         Data: functionalUtility,
  //         additional: additionalAttributes,
  //     })
  // );

  // // heating cooling
  // const heatingCooling = property.getGridField('HeatingCooling');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'HeatingCoolingDescription',
  //         Data: heatingCooling,
  //         additional: additionalAttributes,
  //     })
  // );

  // // energy efficient
  // const energyEfficient = property.getGridField('EnergyEfficient');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'EnergyEfficientItemsDescription',
  //         Data: energyEfficient,
  //         additional: additionalAttributes,
  //     })
  // );

  // // car storage
  // const carStorage = property.getGridField('CarStorage');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'CarStorageDescription',
  //         Data: carStorage,
  //         additional: additionalAttributes,
  //     })
  // );

  // // porch deck
  // const porchDeck = property.getGridField('PorchDeck');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'PorchPatioDeckDescription',
  //         Data: porchDeck,
  //         additional: additionalAttributes,
  //     })
  // );

  // // other feature 1
  // const otherFeature1 = property.getGridField('OtherFeature1');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'BlankDescription',
  //         Data: otherFeature1,
  //         additional: additionalAttributes,
  //     })
  // );

  // // other feature 2
  // const otherFeature2 = property.getGridField('OtherFeature2');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'Blank2Description',
  //         Data: otherFeature2,
  //         additional: additionalAttributes,
  //     })
  // );

  // // other feature 3
  // const otherFeature3 = property.getGridField('OtherFeature3');
  // rptiNodes.push(
  //     createTextFieldNode(doc, {
  //         Id: 'Blank3Description',
  //         Data: otherFeature3,
  //         additional: additionalAttributes,
  //     })
  // );

  // Other Feature 1 Label
  rptiNodes.push(
    createTextFieldNode(doc, {
      Id: 'BlankLabel',
      Data: 'Add. Features',
      additional: {
        CompType: 'SalesComparables',
      },
    }),
  );

  const otherFeature2Label = nodeInput.meta?.otherFeature2Label;
  if (isDefined(otherFeature2Label)) {
    // Other Feature 2 Label
    rptiNodes.push(
      createTextFieldNode(doc, {
        Id: 'Blank2Label',
        Data: otherFeature2Label,
        additional: {
          CompType: 'SalesComparables',
        },
      }),
    );
  }

  return rptiNodes;
};
